// extracted by mini-css-extract-plugin
export var divider = "_nj-0";
export var systemMessage = "_nj-1";